import styled from 'styled-components';

export const Skeleton = styled.div.attrs({
  tabIndex: 0,
  role: 'progressbar',
  'aria-busy': true,
  'aria-valuemin': 0,
  'aria-valuemax': 100,
})`
  --skeleton-highlight: var(--c-nd-50);
  display: inline-block;
  background-color: rgba(var(--c-rgb-white), 0.05);
  background-size: 312px 100%;
  background-repeat: no-repeat;
  border-radius: var(--half-unit);

  position: relative;
  overflow: hidden;
`;
